export function consoleWarn(message: string) {
  console.warn('🤖', message);
}
